import { createSseClient } from '@cascade/core/connection';
import { deployment } from '#config/index.ts';

export const llmSse = createSseClient({ url: deployment.llmUrl });
